var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vuetify-wrapper" }, [
    _c(
      "div",
      { staticClass: "v-application v-application--is-ltr" },
      [
        _c(
          "v-card",
          {
            staticClass: "rounded-lg v-application",
            attrs: { outlined: "", elevation: "0" },
          },
          [
            _c(
              "v-card-text",
              [
                _c(
                  "v-row",
                  { attrs: { dense: "", align: "center" } },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "3" } },
                      [
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "close-on-content-click": false,
                              transition: "scale-transition",
                              "offset-y": "",
                              "min-width": "auto",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-text-field",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              value: _vm.dateLabel,
                                              label: "Datum",
                                              "prepend-inner-icon":
                                                "mdi-calendar",
                                              readonly: "",
                                              clearable: "",
                                              "hide-details": "",
                                              placeholder: "Alle",
                                            },
                                            on: {
                                              "click:clear": _vm.clearDates,
                                            },
                                          },
                                          "v-text-field",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.isDateMenuOpen,
                              callback: function ($$v) {
                                _vm.isDateMenuOpen = $$v
                              },
                              expression: "isDateMenuOpen",
                            },
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "v-date-picker",
                              {
                                attrs: {
                                  multiple: "",
                                  "no-title": "",
                                  locale: "de-DE",
                                  "first-day-of-week": 1,
                                },
                                model: {
                                  value: _vm.selectedDates,
                                  callback: function ($$v) {
                                    _vm.selectedDates = $$v
                                  },
                                  expression: "selectedDates",
                                },
                              },
                              [
                                _c("v-spacer"),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { text: "" },
                                    on: {
                                      click: function ($event) {
                                        _vm.selectedDates = []
                                      },
                                    },
                                  },
                                  [_vm._v("Zurücksetzen")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { text: "", color: "primary" },
                                    on: {
                                      click: function ($event) {
                                        _vm.isDateMenuOpen = false
                                      },
                                    },
                                  },
                                  [_vm._v("Übernehmen")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "3" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Apotheke",
                            "prepend-inner-icon": "mdi-magnify",
                            clearable: "",
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.pharmacy,
                            callback: function ($$v) {
                              _vm.pharmacy = $$v
                            },
                            expression: "pharmacy",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "3" } },
                      [
                        _c("v-select", {
                          staticClass: "wf-state-filter",
                          attrs: {
                            items: _vm.wfStateFilterOptions,
                            label: "Zustand",
                            clearable: "",
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.wfStateFilter,
                            callback: function ($$v) {
                              _vm.wfStateFilter = $$v
                            },
                            expression: "wfStateFilter",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "3" } },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.requestStatusFilterOptions,
                            label: "Anfragestatus",
                            clearable: "",
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.requestStatusFilter,
                            callback: function ($$v) {
                              _vm.requestStatusFilter = $$v
                            },
                            expression: "requestStatusFilter",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("v-data-table", {
              staticClass: "elevation-0 v-application--is-ltr",
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                "server-items-length": _vm.total,
                loading: _vm.isLoading,
                "loading-text": "Wird geladen...",
                "no-data-text": "Keine angefragten Termine",
                options: _vm.tableOptions,
                "disable-filtering": "",
                "footer-props": {
                  "items-per-page-options": [10, 25, 50],
                  "show-first-last-page": true,
                  "items-per-page-text": "Zeilen pro Seite",
                },
              },
              on: {
                "update:options": [
                  function ($event) {
                    _vm.tableOptions = $event
                  },
                  _vm.onOptionsChange,
                ],
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function ({ item }) {
                    return [
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.formatDateRange(item.appointments))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", [
                            item.pharmacy.exists
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: `/pharmacies/${item.pharmacy._id}`,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(item.pharmacy.name) +
                                        "\n                                "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    attrs: {
                                      title: "Diese Apotheke wurde gelöscht.",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(item.pharmacy.name) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-caption grey--text" },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(item.pharmacy.customer_id) +
                                  " · " +
                                  _vm._s(item.pharmacy.zip) +
                                  " " +
                                  _vm._s(item.pharmacy.city) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(item.appointments, function (apt) {
                            return _c(
                              "div",
                              { key: apt.date },
                              [
                                item.appointments.length > 1
                                  ? [
                                      _vm._v(
                                        _vm._s(_vm.formatDayMonth(apt.date)) +
                                          " - "
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(
                                  _vm._s(apt.time_from) +
                                    "-" +
                                    _vm._s(apt.time_to) +
                                    "\n                            "
                                ),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(item.assigned_pharmacist || "-")),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.wfStateLabel(item.wf_state))),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.requestStatusLabel(item.request_status))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatDate(item.request_date))),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }